import styled from "@emotion/styled";

import { fontMerriweather, fontRoboto, theme } from "shared/lib/styles";

import { pageStyle } from "scmp-app/components/article/article-render/article-content/standard-styles";

export {
  Header,
  Time,
} from "scmp-app/components/article/article-render/live-article/content/item/styles";

export const Container = styled.div`
  grid-area: ssr-preview;

  margin-block: 32px;
  padding: 0;

  /*
   * Hide-on-hydrate rule is injected via <Global> in ./index.tsx, not as a
   * "[data-ssr-hydrated] &" rule here: the ampersand compiles to the
   * server-side emotion class hash, which can differ from the client hash
   * after hydration — the rule would then never match and the preview would
   * leak to human users.
   */
`;

export const List = styled.ol`
  margin: 0;
  padding: 0;

  list-style: none;
`;

// Mirrors content/styles.tsx StyledLiveArticleContentItem spacing.
export const Item = styled.li`
  margin-block-start: 40px;

  &:first-of-type {
    margin-block-start: 0;
  }
`;

// Mirrors content/item/styles.tsx Title: Merriweather bold, 18px/23px on
// mobile, 24px/30px on tablet up.
export const Title = styled.div`
  margin-block-end: 12px;

  font-weight: 700;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 23px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 16px;

    font-size: 24px;
    line-height: 30px;
  }
`;

// Mirrors content/item/styles.tsx Authors: Roboto bold #999999, 14px/16px.
export const Authors = styled.div`
  margin-block-end: 12px;

  color: #999999;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 16px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 16px;
  }
`;

// Mirrors content/item/styles.tsx Content: pageStyle gives Merriweather
// 16px / line-height 160% (18px on desktop).
export const Body = styled.div`
  margin-block-end: 20px;

  ${props => pageStyle(props)}
`;
